import { useEffect, useState } from "react";

export default function Kontakt(props) {


  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formSuccess, setFormSuccess] = useState(false);


  function sendContactForm(formData) {

    try {
      setIsSubmitting(true);

      const object = {
        name: formData.get("name"),
        email: formData.get("email"),
        phone: formData.get("phone"),
        message: formData.get("message")
      };

      const fd = new FormData();
      fd.append("name", object.name);
      fd.append("email", object.email);
      fd.append("phone", object.phone);
      fd.append("message", object.message);

      fetch("https://www.mureriocheldstader.se/callback.php", {
        method: "POST",
        body: fd,
        /*headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }*/
      }).then(response => {
        setFormSuccess(true);
      }).catch(error => {
        console.error("There was a problem with the fetch operation:", error);
      }).finally(() => {
        setIsSubmitting(false);
        setTimeout(() => {
          setFormSuccess(false);
        }, 5000); // Reset success message after 5 seconds
      });
    } catch (error) {
      console.error("Error sending contact form:", error);
      setIsSubmitting(false);
    }
  }




  return (
    <article id="offert" >
      <section>
        <h2 id="offert_title">Offert & Kontakt</h2>

        <p>
          <strong>Daniel Haglund</strong><br />
          Tel: 070-214 84 48<br />
          E-post: <a href="mailto:daniel@mureriocheldstader.se">daniel@mureriocheldstader.se</a>
        </p>

        <p>
          För att få en offert på våra tjänster, vänligen fyll i formuläret nedan så kontaktar vi er så snart som möjligt.
        </p>
        {formSuccess ?
          <div id="formSuccess">
            <h3>Tack för ditt meddelande</h3>
            <p>Vi återkommer till dig så fort vi kan!</p>
          </div>
          :
          <form action={sendContactForm} method="post">
            <label htmlFor="name">Namn:</label>
            <input type="text" id="name" name="name" required placeholder="Vad heter du?" />

            <label htmlFor="email">E-post:</label>
            <input type="email" id="email" name="email" required placeholder="E-postadress för kontakt" />

            <label htmlFor="phone">Telefon:</label>
            <input type="tel" id="phone" name="phone" required placeholder="Telefonnummer att ringa" />

            <label htmlFor="message">Meddelande:</label>
            <textarea id="message" name="message" required rows="8" placeholder="Skriv vad du vill ha hjälp med"></textarea>

            <button type="submit" disabled={isSubmitting}>Skicka</button>
          </form>
        }
      </section>
    </article>
  )
}